// GENERATED by scripts/build_process_system_source.py: do not edit by hand.
// The English each built-in process element can carry (seed data + web en wording), lower-cased.
export type ProcessSystemSourceEntry = {
  names: string[];
  descriptions: string[];
  fields: Record<string, string[]>;
  texts: Record<string, string[]>;
  options: Record<string, Record<string, string[]>>;
  nodes: Record<string, string[]>;
};
export const PROCESS_SYSTEM_SOURCE: Record<string, ProcessSystemSourceEntry> = {
  "business_trip": {
    "descriptions": [
      "travel approval that adds finance only for expensive trips.",
      "travel approval that adds finance review only for costly trips."
    ],
    "fields": {
      "destination": [
        "destination"
      ],
      "end_date": [
        "end date"
      ],
      "estimated_cost": [
        "estimated cost"
      ],
      "purpose": [
        "purpose"
      ],
      "start_date": [
        "start date"
      ]
    },
    "names": [
      "business trip"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "cost_route": [
        "estimated cost above 2,000"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "finance approval",
        "finance review"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  },
  "contract_approval": {
    "descriptions": [
      "contract review by the process owner, then finance."
    ],
    "fields": {
      "contract_file": [
        "contract"
      ],
      "contract_value": [
        "contract value"
      ],
      "counterparty": [
        "vendor or counterparty"
      ],
      "start_date": [
        "start date"
      ],
      "summary": [
        "summary"
      ]
    },
    "names": [
      "contract approval"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "finance approval",
        "finance review"
      ],
      "owner_approval": [
        "contract owner review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  },
  "expense_report": {
    "descriptions": [
      "expense claim that adds finance review once the total is high enough.",
      "expense claim with amount-aware finance routing."
    ],
    "fields": {
      "category": [
        "category"
      ],
      "expense_date": [
        "expense date"
      ],
      "notes": [
        "notes"
      ],
      "receipt": [
        "receipt"
      ],
      "total_amount": [
        "total amount"
      ]
    },
    "names": [
      "expense report"
    ],
    "nodes": {
      "amount_route": [
        "total above 500"
      ],
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "finance approval",
        "finance review"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "category": {
        "equipment": [
          "equipment"
        ],
        "meals": [
          "meals"
        ],
        "other": [
          "other"
        ],
        "training": [
          "training"
        ],
        "travel": [
          "travel"
        ]
      }
    },
    "texts": {}
  },
  "general_approval": {
    "descriptions": [
      "a flexible approval for everyday business requests.",
      "request approval for a general business need."
    ],
    "fields": {
      "needed_by": [
        "needed by"
      ],
      "request_details": [
        "request details"
      ],
      "request_title": [
        "request title"
      ]
    },
    "names": [
      "general approval"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  },
  "it_access_request": {
    "descriptions": [
      "request access to a system or shared resource.",
      "request access to a system or work resource."
    ],
    "fields": {
      "access_level": [
        "access level"
      ],
      "justification": [
        "justification"
      ],
      "system_or_resource": [
        "system or resource"
      ]
    },
    "names": [
      "it access request"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "owner_approval": [
        "process owner approval"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "access_level": {
        "administrator": [
          "administrator"
        ],
        "read_only": [
          "read only"
        ],
        "standard": [
          "standard"
        ]
      }
    },
    "texts": {}
  },
  "leave_request": {
    "descriptions": [
      "time-off request routed by length.",
      "time-off request, routed by how many days are asked for."
    ],
    "fields": {
      "end_date": [
        "end date"
      ],
      "leave_note": [
        "before you submit"
      ],
      "leave_type": [
        "leave type"
      ],
      "reason": [
        "reason",
        "reason for leave"
      ],
      "start_date": [
        "start date"
      ],
      "total_days": [
        "total days"
      ]
    },
    "names": [
      "leave request"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "length_route": [
        "more than 3 days"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "skip_level_approval": [
        "senior manager approval",
        "skip-level approval"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "leave_type": {
        "annual": [
          "annual"
        ],
        "parental": [
          "parental"
        ],
        "sick": [
          "sick"
        ],
        "unpaid": [
          "unpaid"
        ]
      }
    },
    "texts": {
      "leave_note": [
        "check your remaining balance first. leave starting within 48 hours may need a call to your manager as well."
      ]
    }
  },
  "local_acceptance_it_access_request": {
    "descriptions": [
      "request access to a system or work resource."
    ],
    "fields": {
      "access_level": [
        "access level"
      ],
      "justification": [
        "business reason"
      ],
      "organization_location": [
        "organization location"
      ],
      "system_or_resource": [
        "system or resource"
      ]
    },
    "names": [
      "it access request"
    ],
    "nodes": {
      "approval": [
        "manager review"
      ],
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "access_level": {
        "administrator": [
          "administrator"
        ],
        "read": [
          "read"
        ],
        "write": [
          "write"
        ]
      }
    },
    "texts": {}
  },
  "local_acceptance_leave_request": {
    "descriptions": [
      "request annual, sick, or unpaid leave with supporting details."
    ],
    "fields": {
      "days_requested": [
        "days requested"
      ],
      "end_date": [
        "end date"
      ],
      "leave_type": [
        "leave type"
      ],
      "organization_location": [
        "organization location"
      ],
      "reason": [
        "reason"
      ],
      "start_date": [
        "start date"
      ],
      "supporting_document": [
        "supporting document"
      ],
      "worker_name": [
        "employee name"
      ]
    },
    "names": [
      "employee leave request"
    ],
    "nodes": {
      "approval": [
        "manager review"
      ],
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "leave_type": {
        "annual": [
          "annual leave"
        ],
        "maternity": [
          "maternity leave"
        ],
        "sick": [
          "sick leave"
        ],
        "unpaid": [
          "unpaid leave"
        ]
      }
    },
    "texts": {}
  },
  "local_acceptance_purchase_approval": {
    "descriptions": [
      "request approval for a business purchase and attach an invoice when available."
    ],
    "fields": {
      "category": [
        "category"
      ],
      "delivery_location": [
        "delivery location"
      ],
      "description": [
        "purchase description"
      ],
      "estimated_cost": [
        "estimated cost"
      ],
      "expense_date": [
        "purchase date"
      ],
      "invoice": [
        "invoice"
      ]
    },
    "names": [
      "purchase approval"
    ],
    "nodes": {
      "amount_route": [
        "estimated cost above 500"
      ],
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "finance review"
      ],
      "manager_approval": [
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "category": {
        "meals": [
          "meals"
        ],
        "office_supplies": [
          "office supplies"
        ],
        "other": [
          "other"
        ],
        "software": [
          "software"
        ],
        "travel": [
          "travel"
        ]
      }
    },
    "texts": {}
  },
  "local_acceptance_vendor_contract_review": {
    "descriptions": [
      "send a vendor contract for owner and finance review."
    ],
    "fields": {
      "contract_document": [
        "contract document"
      ],
      "contract_value": [
        "contract value"
      ],
      "effective_date": [
        "effective date"
      ],
      "expiry_date": [
        "expiry date"
      ],
      "notes": [
        "notes"
      ],
      "organization_location": [
        "organization location"
      ],
      "vendor_name": [
        "vendor name"
      ]
    },
    "names": [
      "vendor contract review"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "archive_cc": [
        "share the approved result"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "finance review"
      ],
      "owner_approval": [
        "contract owner review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  },
  "offboarding": {
    "descriptions": [
      "departure confirmation, then final settlement."
    ],
    "fields": {
      "departing_worker": [
        "departing worker"
      ],
      "handover_notes": [
        "handover notes"
      ],
      "last_working_day": [
        "last working day"
      ],
      "reason": [
        "reason",
        "reason for leaving"
      ]
    },
    "names": [
      "offboarding"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "final settlement"
      ],
      "manager_approval": [
        "manager confirmation"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {
      "reason": {
        "end_of_contract": [
          "end of contract"
        ],
        "other": [
          "other"
        ],
        "resignation": [
          "resignation"
        ],
        "retirement": [
          "retirement"
        ]
      }
    },
    "texts": {}
  },
  "onboarding": {
    "descriptions": [
      "new joiner setup: hiring manager approval, then coordination.",
      "new joiner setup: hiring manager, then coordination."
    ],
    "fields": {
      "buddy": [
        "onboarding buddy"
      ],
      "department": [
        "department"
      ],
      "new_joiner_name": [
        "new joiner"
      ],
      "onboarding_note": [
        "how this works"
      ],
      "position": [
        "position"
      ],
      "start_date": [
        "start date"
      ]
    },
    "names": [
      "onboarding"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "manager_approval": [
        "hiring manager approval"
      ],
      "owner_approval": [
        "setup coordination"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {
      "onboarding_note": [
        "submit this once the offer is signed. the equipment and account setup starts after the second approval."
      ]
    }
  },
  "overtime_request": {
    "descriptions": [
      "overtime approval that chases itself when it goes overdue.",
      "overtime approval that sends a reminder when it becomes overdue."
    ],
    "fields": {
      "hours": [
        "hours"
      ],
      "overtime_date": [
        "date"
      ],
      "reason": [
        "reason",
        "reason for overtime"
      ]
    },
    "names": [
      "overtime request"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  },
  "procurement_request": {
    "descriptions": [
      "vendor purchase needing both a manager and the process owner.",
      "vendor purchase that needs both a manager and the process owner."
    ],
    "fields": {
      "business_need": [
        "business need"
      ],
      "estimated_cost": [
        "estimated cost"
      ],
      "item_or_service": [
        "item or service"
      ],
      "quantity": [
        "quantity"
      ],
      "vendor_name": [
        "vendor"
      ]
    },
    "names": [
      "procurement request"
    ],
    "nodes": {
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "owner_approval": [
        "process owner approval"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  },
  "purchase_request": {
    "descriptions": [
      "purchase approval with amount-aware finance routing.",
      "request approval to buy a product or service."
    ],
    "fields": {
      "business_need": [
        "business need"
      ],
      "estimated_cost": [
        "estimated cost"
      ],
      "item_or_service": [
        "item or service"
      ],
      "needed_by": [
        "needed by"
      ],
      "quantity": [
        "quantity"
      ]
    },
    "names": [
      "purchase request"
    ],
    "nodes": {
      "amount_route": [
        "estimated cost above 1,000"
      ],
      "approved_notification": [
        "notify approved result"
      ],
      "end": [
        "end"
      ],
      "finance_approval": [
        "finance approval",
        "finance review"
      ],
      "manager_approval": [
        "manager approval",
        "manager review"
      ],
      "rejected_notification": [
        "notify rejected result"
      ],
      "start": [
        "submit"
      ]
    },
    "options": {},
    "texts": {}
  }
};
